import { cx } from './cx.js';

export interface SpinnerProps {
  /** Announced to screen readers. */
  label?: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function Spinner({ label = 'Loading', size = 'md', className }: SpinnerProps) {
  return (
    <span role="status" className={cx('qk-spinner', `qk-spinner--${size}`, className)}>
      <span className="qk-spinner__ring" aria-hidden="true" />
      <span className="qk-sr-only">{label}</span>
    </span>
  );
}
